import React, {Component} from "react";
import {Button} from "primereact/button";
import AvailableValuesFid from "./AvailableValuesFidView"

export default class AvailableValuesFidContainer extends Component {
    render() {
        var headerAvailableValuesFid =
            <div style={{textAlign: 'right'}}>
                <Button type="button" iconPos="left" label="Cargar Disponibilidad" style={{marginRight: '.5em'}}/>
                <Button icon="pi pi-refresh" style={{'float': 'right'}}/>
            </div>;

        return <AvailableValuesFid headerAvailableValuesFid={headerAvailableValuesFid}/>
    }
};